import { combineReducers } from 'redux';
import loading from './loading';
import { authenticationReducer } from './authentication';
import { alertDialog } from './alertDialog';
import { themeReducer } from './theme';
import { viewModeReducer } from './viewMode';


const rootReducer = combineReducers({
    authentication: authenticationReducer,    
    loading,
    alertDialog,
    theme: themeReducer,
    viewMode: viewModeReducer
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;